// Hides the default Zendesk button

window.zE("webWidget", "hide");
window.zE("webWidget:on", "close", () => {
  window.zE("webWidget", "hide");
});
